(function ( $ ) {
    (function () {
        $("#registration-form").submit(function (e) {
            e.preventDefault();
            let name = $(".registration-form [name=\"name\"]").val();
            let phoneNumber = $(".registration-form [name=\"phone\"]").val();
            let email = $(".registration-form [name=\"email\"]").val();
            let password = $(".registration-form [name=\"password\"]").val();
            let token = $('meta[name="csrf-token"]').attr('content');

            $('#registration-form .edit-error-name').html('');
            $('#registration-form .edit-error-phone').html('');
            $('#registration-form .edit-error-email').html('');
            $('#registration-form .edit-error-password').html('');

            $("#registration-form .spinner-for-btn").css('display','inline-block');
            $("#registration-form  input[type='submit']").prop('disabled', true);

            axios
                .post(`/register`, {
                    name: name,
                    phoneNumber: phoneNumber,
                    email: email,
                    password: password,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(response => {
                    // console.log(response.data);
                    $('html').addClass('open-frame');
                    $('.popup-frame').css("display", "flex").hide().fadeIn();

                    if (response.data.login_via_email) {
                        $('.user-register-completed').fadeIn();
                    } else {
                        $('#register_confirm-form').fadeIn();
                        $('#register_confirm-form [name="phoneNumber"]').val(phoneNumber);

                    }
                })
                .catch(error => {

                    let errors = error.response.data.errors;

                    if (error.response.status === 503) {
                        $('#registration-form .edit-error-password').html(error.response.data.errors);
                    }

                    if (errors.hasOwnProperty('name')) {
                        $('#registration-form .edit-error-name').html(errors.name.join(', '));
                    }
                    if (errors.hasOwnProperty('phoneNumber')) {
                        $('#registration-form .edit-error-phone').html(errors.phoneNumber.join(', '));
                    }
                    if (errors.hasOwnProperty('email')) {
                        $('#registration-form .edit-error-email').html(errors.email.join(', '));
                    }
                    if (errors.hasOwnProperty('password')) {
                        $('#registration-form .edit-error-password').html(errors.password.join(', '));
                    }
                })
                .then(() => {
                    $("#registration-form .spinner-for-btn").hide();
                    $("#registration-form  input[type='submit']").prop('disabled', false);
                });
        })

        $("#register_confirm-form, #register_confirm_form_on_login").submit(function (e) {
            e.preventDefault();
            let email_verify_token = $(this).find("[name=\"code\"]").val();
            let phoneNumber = $(this).find("[name=\"phoneNumber\"]").val();
            let token = $('meta[name="csrf-token"]').attr('content');

            $('#register_confirm-form .edit-error-code').html('');

            $(this).find(".spinner-for-btn").css('display','inline-block');
            $(this).find("input[type='submit']").prop('disabled', true);

            axios
                .post(`/ajax/register/sms/confirm`, {
                    email_verify_token: email_verify_token,
                    phoneNumber: phoneNumber,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(response => {
                    // console.log(response.data);
                    $('#register_confirm-form').fadeOut();
                    $('.popup-frame').fadeOut();
                    $('html').removeClass('open-frame');

                    let pathArray = window.location.pathname.split('/');
                    let lang = pathArray[1];

                    if (lang === "ua") {
                        window.location.replace("/ua/account");
                    } else {
                        window.location.replace("/account");
                    }

                })
                .catch(error => {

                    let errors = error.response.data.errors;

                    if (error.response.status === 503) {
                        $('#register_confirm-form .edit-error-code').html(error.response.data.errors);
                    }

                    console.log(errors);
                    if (errors.hasOwnProperty('email_verify_token')) {
                        $('#register_confirm-form .edit-error-code').html(errors.email_verify_token.join(', '));
                        $('#register_confirm_form_on_login .edit-error-code').html(errors.email_verify_token.join(', '));
                    }
                })
                .then(() => {
                    $(this).find(".spinner-for-btn").hide();
                    $(this).find("input[type='submit']").prop('disabled', false);
                });
        })
    }());

}( jQuery ));


